module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.reschedulingInfo.receiver.id !== _vm.$store.state.userInfo.user_id) ? _c('div', {
    key: "unauthorized"
  }, [_vm._m(0)]) : (_vm.reschedulingInfo.status !== 'pending') ? _c('div', {
    key: "got-result"
  }, [_vm._m(1)]) : _c('div', {
    key: "receiver-confirmation"
  }, [(!_vm.reschedulingInfo.isDenying) ? _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("以下の内容で授業振替を承認します")]), _vm._v(" "), _c('h1', {
    staticClass: "section-description"
  }, [_vm._v("よろしければ「振替を確定する」ボタンを押してください")]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v("振替前の授業")]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', [(_vm.reschedulingInfo.sender.user_type === 'teacher') ? _c('label', {
    key: "teacher-name"
  }, [_vm._v("\n              先生のお名前：" + _vm._s(_vm.reschedulingInfo.sender.fullname) + " 先生\n            ")]) : _vm._e(), _vm._v(" "), (_vm.reschedulingInfo.sender.user_type === 'student') ? _c('label', {
    key: "student-name"
  }, [_vm._v("\n              生徒のお名前：" + _vm._s(_vm.reschedulingInfo.sender.fullname) + " 様\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', [_c('label', [_vm._v("日付　　　　：" + _vm._s(_vm.formattedDate(_vm.reschedulingInfo.target_reservation.date)))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("時間　　　　：" + _vm._s(_vm.reschedulingInfo.target_reservation.start_time.slice(0, -2)) + " 〜 " + _vm._s(_vm.reschedulingInfo.target_reservation.end_time.slice(0, -2)) + "の１コマ")])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("座席　　　　：" + _vm._s(_vm.reschedulingInfo.target_reservation.classroom_name))])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v("振替後の授業")]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', [(_vm.reschedulingInfo.sender.user_type === 'teacher') ? _c('label', {
    key: "teacher-name"
  }, [_vm._v("\n              先生のお名前：" + _vm._s(_vm.reschedulingInfo.sender.fullname) + " 先生\n            ")]) : _vm._e(), _vm._v(" "), (_vm.reschedulingInfo.sender.user_type === 'student') ? _c('label', {
    key: "student-name"
  }, [_vm._v("\n              生徒のお名前：" + _vm._s(_vm.reschedulingInfo.sender.fullname) + " 様\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', [_c('label', [_vm._v("日付　　　　：" + _vm._s(_vm.formattedDate(_vm.reschedulingInfo.rescheduled_reservation.date)))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("時間　　　　：" + _vm._s(_vm.reschedulingInfo.rescheduled_reservation.start_time) + " 〜 " + _vm._s(_vm.reschedulingInfo.rescheduled_reservation.end_time) + "の１コマ")])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("座席　　　　：" + _vm._s(_vm.reschedulingInfo.rescheduled_reservation.classroom_name))])]), _vm._v(" "), (_vm.reschedulingInfo.receiver.user_type === 'teacher') ? _c('div', [_c('div', [_c('label', [_vm._v("授業の種類　　　　　　：" + _vm._s(_vm.reschedulingInfo.reservationOption.reservationType === '短期' ? '短期講座' : _vm.reschedulingInfo.reservationOption.reservationType + '授業'))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("配布物（確認テスト等）：" + _vm._s(_vm.reschedulingInfo.reservationOption.hasTest ? 'あり' : 'なし'))])]), _vm._v(" "), (_vm.reschedulingInfo.reservationOption.reservationMessage) ? _c('div', [_c('label', [_vm._v("連絡事項：")]), _vm._v(" "), _vm._l((_vm.reschedulingInfo.reservationOption.reservationMessage.split('\n')), function(row) {
    return _c('div', {
      key: "message-row",
      staticClass: "message-row"
    }, [_c('label', [_vm._v("　" + _vm._s(row))])])
  })], 2) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-cancel",
    on: {
      "click": function($event) {
        _vm.cancelButtonClicked()
      }
    }
  }, [_vm._v("\n        戻って修正する\n      ")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-ok",
    on: {
      "click": function($event) {
        _vm.confirmButtonClicked()
      }
    }
  }, [_vm._v("\n        振替を確定する\n      ")])], 1) : _vm._e(), _vm._v(" "), (_vm.reschedulingInfo.isDenying) ? _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("振替依頼を不承認し、他の振替候補日時を提案します")]), _vm._v(" "), _c('h1', {
    staticClass: "section-description"
  }, [_vm._v("よろしければ「完了」ボタンを押してください")]), _vm._v(" "), (_vm.reschedulingInfo.receiver_message) ? _c('div', {
    staticClass: "info"
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v(_vm._s(_vm.senderDisplayName) + "へのメッセージ")]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('label', [_vm._v(_vm._s(_vm.reschedulingInfo.receiver_message))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('h1', {
    staticClass: "info-caption"
  }, [_vm._v("他の振替候補日時")]), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('ul', {
    attrs: {
      "id": "candidate-list"
    }
  }, _vm._l((_vm.reschedulingInfo.alternative_datetimes), function(alternative_datetimes, index) {
    return _c('li', {
      key: 'alternative_datetimes' + index
    }, [_c('div', {
      staticClass: "alternative_datetimes-caption"
    }, [_c('i', {
      staticClass: "el-icon-caret-right"
    }), _vm._v(" "), _c('label', [_vm._v("候補" + _vm._s(index + 1))])]), _vm._v(" "), _c('div', {
      staticClass: "alternative_datetimes-content"
    }, [_c('div', [_c('label', [_vm._v("日付：" + _vm._s(_vm.formattedDate(alternative_datetimes.date)))])]), _vm._v(" "), _c('div', [_c('label', [_vm._v("時間：" + _vm._s(alternative_datetimes.start_time) + " 〜 " + _vm._s(alternative_datetimes.end_time))]), _vm._v(" "), _c('label', [_vm._v(_vm._s(alternative_datetimes.mode === 'slot' ? 'の1コマ' : 'の中で' + alternative_datetimes.duration + '分間'))])])])])
  }))])]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-cancel",
    on: {
      "click": function($event) {
        _vm.cancelButtonClicked()
      }
    }
  }, [_vm._v("\n        戻って修正する\n      ")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-ok",
    on: {
      "click": function($event) {
        _vm.denyButtonClicked()
      }
    }
  }, [_vm._v("\n        完了\n      ")])], 1) : _vm._e()])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("授業振替情報を表示する権限がありません")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('h1', {
    staticClass: "section-description"
  }, [_vm._v("指定された授業振替情報は承認または非承認しております")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('i', {
    staticClass: "el-icon-back down-arrow"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-445cf68a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-445cf68a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReschedulingPage/ReschedulingReceiverConfirmation.vue
// module id = 700
// module chunks = 0